import React from "react";
import { Check } from "lucide-react";

export default function StepIndicator({ steps, current }) {
  return (
    <div className="flex items-center gap-2 mb-6" data-testid="step-indicator">
      {steps.map((label, i) => {
        const idx = i + 1;
        const isDone = idx < current;
        const isActive = idx === current;
        return (
          <React.Fragment key={label}>
            <div className="flex items-center gap-2 min-w-0">
              <div
                className={[
                  "w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 transition-all",
                  isDone
                    ? "bg-[#00357C] text-white"
                    : isActive
                    ? "bg-[#00357C] text-white ring-4 ring-[#D6E1EE]"
                    : "bg-slate-200 text-slate-500",
                ].join(" ")}
                data-testid={`step-${idx}-${isActive ? "active" : isDone ? "done" : "pending"}`}
              >
                {isDone ? <Check size={14} /> : idx}
              </div>
              <span
                className={[
                  "text-xs hidden sm:inline truncate",
                  isActive ? "text-slate-900 font-medium" : "text-slate-500",
                ].join(" ")}
              >
                {label}
              </span>
            </div>
            {idx < steps.length && (
              <div className={`h-px flex-1 ${idx < current ? "bg-[#00357C]" : "bg-slate-200"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
